import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { getCreditPlanDisplayName } from '../../../../utils/AppUtil';

const i18n = defineMessages({
  standard: {
    id: 'dashboard.dashboard-account-information.standard-credits-consumption',
    defaultMessage: 'Standard credits consumption',
  },
  unlimited: {
    id: 'dashboard.dashboard-account-information.unlimited-credits',
    defaultMessage: 'Unlimited',
  },
  noLimit: {
    id: 'dashboard.dashboard-account-information.no-limit',
    defaultMessage: 'NoLimit',
  },
});

const AccountInformation = ({ accountData }) => {
  const { id, currentCreditPlan, creditPlanExpirationDate } = accountData;

  const { formatMessage, formatDate } = useIntl();

  const creditPlanDisplayName = getCreditPlanDisplayName(
    currentCreditPlan,
    formatMessage(i18n.standard),
    formatMessage(i18n.unlimited),
    formatMessage(i18n.noLimit),
  );
  const expirationDate = creditPlanExpirationDate
    ? formatDate(moment(creditPlanExpirationDate), {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      })
    : '-';

  return (
    <>
      <div className="dashboard-data-container">
        <div>
          <FormattedMessage
            id="dashboard.dashboard-account-information.title"
            defaultMessage="Account information"
            tagName="strong"
          />
        </div>
        <div className="data">
          <FormattedMessage id="dashboard.dashboard-account-information.id" defaultMessage="ID:" />
          <span>{id}</span>
        </div>
        <div className="data">
          <span>
            <FormattedMessage id="lbl.plan" defaultMessage="Plan" />
            <strong>: </strong>
          </span>
          <span>{creditPlanDisplayName}</span>
        </div>
        <div className="data">
          <FormattedMessage
            id="dashboard.dashboard-account-information.credit-plan-expiration-date"
            defaultMessage="Renewal/expiration date:"
          />
          <span>{expirationDate}</span>
        </div>
      </div>
    </>
  );
};

AccountInformation.propTypes = {
  accountData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AccountInformation;
